module.exports = __webpack_public_path__ + "img/icon-over.c08bfdf6.png";